import React from "react";
import { renderHeader } from "@amitasoft/site-shell";
import { useLocation } from "react-router-dom";

export default function LandingAppBar() {
  const location = useLocation();
  return (
    <div
      className="as-shell-mount"
      dangerouslySetInnerHTML={{ __html: renderHeader({ currentPath: location.pathname }) }}
    />
  );
}
